import { ReactNode } from "react";
import SettingButton from "./SettingButton";
import { Switch } from "../ui/Switch";

export default function SettingButtonSwitch({
  checked,
  children,
  iconName,
  iconScale,
  icon,
  onClick,
}: {
  checked: boolean;
  children?: ReactNode;
  iconName?: string;
  iconScale?: number;
  icon?: ReactNode;
  onClick?: () => void;
}) {
  return (
    <SettingButton
      iconName={iconName}
      iconScale={iconScale}
      icon={icon}
      onClick={onClick}
      inputChild={
        <Switch
          checked={checked}
          onCheckedChange={() => {
            // Toggle is dispatched by the row-level SettingButton onClick;
            // the Switch click bubbles up to it.
          }}
        />
      }
    >
      {children}
    </SettingButton>
  );
}
